module.exports = __webpack_public_path__ + "static/img/Energy-Access-Ventures_logo.ea6ccfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Energy-Access-Ventures_logo.png
// module id = X/dv
// module chunks = 0